import { useAuth } from '../../../src/context/AuthContext';
import ReviewerHomeScreen from '../../../src/screens/ReviewerHomeScreen';
import OwnerHomeScreen from '../../../src/screens/OwnerHomeScreen';
import AdminDisputesScreen from '../../../src/screens/AdminDisputesScreen';

export default function HomeTab() {
  const { user, activeMode } = useAuth();
  if (user?.role === 'ADMIN') return <AdminDisputesScreen />;
  return activeMode === 'SHOP_OWNER' ? <OwnerHomeScreen /> : <ReviewerHomeScreen />;
}
